// 0x Cross Chain errors
export const ZERO_X_CROSS_CHAIN_ERROR = {
  TOKEN_ON_SAME_NETWORK: 'Token On Same Network',
  SUPERSTATE_TOKEN_UNSUPPORTED: 'Superstate Token Unsupported',
  NO_QUOTES_AVAILABLE: 'No Quotes Available',
  FAILED_TO_FETCH_QUOTE: 'Failed To Fetch Quote',
  FAILED_TO_FETCH_STATUS: 'Failed To Fetch Status',
  INSUFFICIENT_LIQUIDITY: 'Insufficient Liquidity',
  INSUFFICIENT_INPUT_AMOUNT: 'Insufficient Sell Amount',
  FAILED_TO_SUBMIT_TX: 'Failed To Submit Tx',
  APPROVAL_REQUIRED: 'Token Approval Required',
  INSUFFICIENT_BALANCE: 'Insufficient Balance',
} as const;
